import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { INCOMING } from '../../constants';
import type { OnUnlinkCallback, Appearance } from '../../types';

export const createUnlinkHandler =
	(fromId: string, toId: string, onUnlink: OnUnlinkCallback, callback?: () => void) =>
	(analyticsEvent: UIAnalyticsEvent) => {
		onUnlink({ dependency: fromId, dependee: toId }, analyticsEvent);

		if (callback) {
			callback();
		}
	};

export const createUnlinkHandlerByAppearance = (
	fromId: string,
	toId: string,
	appearance: Appearance,
	onUnlink: OnUnlinkCallback,
	callback?: () => void,
) =>
	appearance === INCOMING
		? createUnlinkHandler(toId, fromId, onUnlink, callback)
		: createUnlinkHandler(fromId, toId, onUnlink, callback);
